import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { pickLang } from "../lib/i18n";
import { api } from "../lib/api";
import { ArrowLeft } from "@phosphor-icons/react";
import { youTubeEmbed } from "../lib/youtube";
import SEO from "../components/SEO";

export default function VlogDetail() {
  const { slug } = useParams();
  const { lang } = useLang();
  const [vlog, setVlog] = useState(null);

  useEffect(() => { api.get(`/vlogs/${slug}`).then((r) => setVlog(r.data)).catch(() => setVlog(false)); }, [slug]);

  if (vlog === null) return <div className="max-w-3xl mx-auto px-5 py-32 text-gray-400">Loading...</div>;
  if (vlog === false) return <div className="max-w-3xl mx-auto px-5 py-32 text-gray-400">Not found. <Link to="/vlogs" className="link-neon">Back</Link></div>;

  const embed = youTubeEmbed(vlog.video_url);

  return (
    <article className="max-w-4xl mx-auto px-5 sm:px-8 py-16" data-testid="vlog-detail-page">
      <SEO
        title={vlog.title}
        description={vlog.description}
        image={vlog.thumbnail}
        path={`/vlogs/${vlog.slug}`}
      />
      <Link to="/vlogs" className="inline-flex items-center gap-2 mono-font text-xs uppercase tracking-[0.2em] text-gray-400 hover:text-[#ccff00] mb-10">
        <ArrowLeft size={14} /> {lang === "gr" ? "Πίσω" : "Back to vlogs"}
      </Link>

      <div className="flex flex-wrap gap-2 mb-4">
        {(vlog.tags || []).map((tag) => (
          <span key={tag} className="mono-font text-[10px] uppercase tracking-[0.2em] text-[#ccff00] border border-[#ccff00]/40 px-2 py-1">{tag}</span>
        ))}
      </div>
      <h1 className="display-font text-4xl sm:text-5xl font-black uppercase tracking-tighter leading-[0.95]">
        {pickLang(vlog.title, lang)}
      </h1>
      <div className="mono-font text-xs text-gray-500 mt-3">{vlog.author} · {new Date(vlog.created_at).toLocaleDateString(lang === "gr" ? "el-GR" : "en-GB")}{vlog.duration ? ` · ${vlog.duration}` : ""}</div>

      <div className="mt-10 aspect-video bg-[#0a0a0c] border border-[#2a2a35]" data-testid="vlog-iframe-wrap">
        {embed ? (
          <iframe
            src={embed}
            title={pickLang(vlog.title, lang)}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-full h-full"
            data-testid="vlog-iframe"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-500 mono-font text-sm">// VIDEO UNAVAILABLE</div>
        )}
      </div>

      <p className="text-gray-200 mt-10 leading-relaxed whitespace-pre-wrap">
        {pickLang(vlog.description, lang)}
      </p>
    </article>
  );
}
